export default __webpack_public_path__ + "static/content-4d9e5db71cdfe3b9637d70aebb909273.jpg";